import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const DepositPaychecksJoint: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="51px"
            height="59px"
            viewBox="0 0 51 59"
            fill="none"
            {...props}
        >
            <path
                d="M43.2373 0.806642C43.6515 0.806641 43.9873 1.14243 43.9873 1.55664C43.9873 1.97085 43.6515 2.30664 43.2373 2.30664L43.2373 0.806642ZM25.75 19.794L25.75 22.7227L24.25 22.7227L24.25 19.794L25.75 19.794ZM24.25 19.794C24.25 9.30757 32.7509 0.806659 43.2373 0.806642L43.2373 2.30664C33.5793 2.30666 25.75 10.136 25.75 19.794L24.25 19.794Z"
                fill="#C0C2C6"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.7529 0.7600 0.7780)' }}
            />
            <path
                d="M0.238281 34.0566C0.238281 33.2282 0.909854 32.5566 1.73828 32.5566H25.2383V58.5566H1.73828C0.909854 58.5566 0.238281 57.8851 0.238281 57.0566V34.0566Z"
                fill="#CF7135"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
            />
            <path
                d="M50.2383 57.0566C50.2383 57.8851 49.5667 58.5566 48.7383 58.5566L25.2383 58.5566L25.2383 32.5566L48.7383 32.5566C49.5667 32.5566 50.2383 33.2282 50.2383 34.0566L50.2383 57.0566Z"
                fill="#6DBBF3"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
            />
            <path
                d="M24.707 23.253C24.9999 23.5459 25.4747 23.5459 25.7676 23.253L30.5406 18.4801C30.8335 18.1872 30.8335 17.7123 30.5406 17.4194C30.2477 17.1265 29.7728 17.1265 29.4799 17.4194L25.2373 21.662L20.9947 17.4194C20.7018 17.1265 20.2269 17.1265 19.934 17.4194C19.6411 17.7123 19.6411 18.1872 19.934 18.4801L24.707 23.253ZM7 0.806642C6.58579 0.806641 6.25 1.14243 6.25 1.55664C6.25 1.97085 6.58578 2.30664 7 2.30664L7 0.806642ZM24.4873 19.794L24.4873 22.7227L25.9873 22.7227L25.9873 19.794L24.4873 19.794ZM25.9873 19.794C25.9873 9.30757 17.4864 0.806659 7 0.806642L7 2.30664C16.658 2.30666 24.4873 10.136 24.4873 19.794L25.9873 19.794Z"
                fill="#C0C2C6"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.7529 0.7600 0.7780)' }}
            />
        </IconSVG>
    );
};
